module.exports = __webpack_public_path__ + "static/media/Italian_traffic_signs_Coda-CL.d1305510.svg";